import { reduxForm, reset } from 'redux-form'
import moment from 'moment'

import MessageForm from '../../components/messages/message-form'

import { createMessageForWorkOrder } from '../../actions/messages'

const fields = [
  'body',
  'timezone'
]

function mapDispatchToProps (dispatch, ownProps) {
  return {
    onSubmit (data) {
      dispatch(createMessageForWorkOrder(ownProps.workOrderId, data))
        .then(() => dispatch(reset('createWorkOrderMessage')))
    }
  }
}

export default reduxForm(
  {
    fields,
    initialValues: {
      timezone: moment.tz.guess()
    },
    form: 'createWorkOrderMessage'
  },
  undefined,
  mapDispatchToProps
)(MessageForm)



// WEBPACK FOOTER //
// ./src/containers/messages/create-work-order-message-container.js